// Light haptic feedback helper — works on iOS PWA + Android + most modern browsers
export function haptic(pattern = 15) {
  try {
    if (typeof window !== "undefined" && "vibrate" in navigator) {
      navigator.vibrate(pattern);
    }
  } catch { /* ignore */ }
}

export const tapHaptic = () => haptic(10);
export const successHaptic = () => haptic([15, 50, 15]);
export const warnHaptic = () => haptic([40, 30, 40]);
